import { API_TAGS } from '../../constants/api';
import { apiSlice } from '../apiSlice';
import { MESSAGES } from './nlpFlowsMessages';

export const nlpFlowsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchNlpFlows: builder.query({
      query: ({ orgId, tenantId, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/nlp-pipelines/trees`,
        method: 'GET',
        params: {
          pageSize: 100,
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_NLP_FLOWS.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        if (error?.error) {
          return [{ type: API_TAGS.NLP_FLOWS, id: 'LIST' }];
        }
        return [
          ...result.items.map(({ id }) => ({ type: API_TAGS.NLP_FLOWS, id })),
          { type: API_TAGS.NLP_FLOWS, id: 'LIST' }
        ];
      }
    }),

    fetchNlpFlow: builder.query({
      query: ({ orgId, tenantId, nlpFlowId, showError = true, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/nlp-pipelines/trees/${nlpFlowId}`,
        method: 'GET',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: showError,
          messages: MESSAGES.FETCH_NLP_FLOW.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        return [
          { type: API_TAGS.NLP_FLOWS, id: args.nlpFlowId }
        ];
      }
    }),

    createNlpFlow: builder.mutation({
      query: ({ orgId, tenantId, data, urlParams = {}, successMessage = { showMessage: true } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/nlp-pipelines/trees`,
        method: 'POST',
        params: {
          ...urlParams
        },
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.CREATE_NLP_FLOW.ERROR
        }
      }),
      invalidatesTags: (result, error, args) => {
        if (error) {
          return;
        }
        return [
          { type: API_TAGS.NLP_FLOWS, id: 'LIST' },
          { type: API_TAGS.BOTS, id: args.tenantId }
        ];
      }
    }),

    updateNlpFlow: builder.mutation({
      query: ({ orgId, tenantId, nlpFlowId, data, urlParams = {}, successMessage = { showMessage: true } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/nlp-pipelines/trees/${nlpFlowId}`,
        method: 'PATCH',
        params: {
          ...urlParams
        },
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_NLP_FLOW.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.UPDATE_NLP_FLOW.SUCCESS
        }
      }),
      transformResponse: (response) => true,
      invalidatesTags: (result, error, args) => {
        if (error) {
          return;
        }
        return [
          { type: API_TAGS.NLP_FLOWS, id: args.nlpFlowId },
          { type: API_TAGS.BOTS, id: args.tenantId }
        ];
      }
    }),

    deleteNlpFlow: builder.mutation({
      query: ({ orgId, tenantId, nlpFlowId, urlParams = {}, successMessage = { showMessage: true } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/nlp-pipelines/trees/${nlpFlowId}`,
        method: 'DELETE',
        params: {
          ...urlParams
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.DELETE_NLP_FLOW.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.DELETE_NLP_FLOW.SUCCESS
        }
      }),
      invalidatesTags: (result, error, args) => {
        if (error) {
          return;
        }
        return [
          { type: API_TAGS.NLP_FLOWS, id: 'LIST' },
          { type: API_TAGS.BOTS, id: args.tenantId }
        ];
      }
    })
  })
});

export const {
  useFetchNlpFlowsQuery,
  useFetchNlpFlowQuery,
  useCreateNlpFlowMutation,
  useUpdateNlpFlowMutation,
  useDeleteNlpFlowMutation
} = nlpFlowsSlice;
